import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.API_HOST)) {
    return next(req);
  }
  return next(req.clone({
    withCredentials: true,
    setHeaders: {
      'x-requested-by': 'cambios-devoluciones',
      'tipo-auth': 'CustomToken'
    }
  }));
};
